import { useExtraRatesApi } from '@api/demo-slots/extra-rates.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(() => {
  void useExtraRatesApi()
})
